import { EUROPACE_PORTAL_LINK_KINDS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    europaceOfferId: string;
    id: string;
};

export const schemaLoanRequestResolver_GetEuropacePortalLink = z.discriminatedUnion('kind', [
    z.object({
        authorization: z.string().min(1),
        kind: z.literal(EUROPACE_PORTAL_LINK_KINDS.AVAILABLE),
        url: z.string().url().startsWith('https://'),
    }),
    z.object({ expiresAt: z.coerce.date(), kind: z.literal(EUROPACE_PORTAL_LINK_KINDS.EXPIRED) }),
    z.object({ kind: z.literal(EUROPACE_PORTAL_LINK_KINDS.UNAVAILABLE) }),
]);

export type SchemaLoanRequestResolver_GetEuropacePortalLink = z.infer<
    typeof schemaLoanRequestResolver_GetEuropacePortalLink
>;

export type LoanRequestResolver_GetEuropacePortalLink = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetEuropacePortalLink
>;
